module.exports = __webpack_public_path__ + "img/VULlogo.7e62f406.png";